
/// <amd-module name="VC/Pullrequest/Common/GutterAdornments" />
export interface IGutterAdornmentBlock {

    /** Starting line number for which Adornment needs to be defined. */
    LineNumberStart: number;

    /** Number of lines from LineNumberStart that needs to this Adornment. */
    LinesCount: number;

    /** Indicator type. */
    IndicatorType: IndicatorType;

    /** Help text for the icon. */
    HelpText: string;
}

export interface IGutterAdornmentCollection {

    /** Adornment data for modified file. */
    modifiedFilegutterAdornments: IGutterAdornmentBlock[];

    /** Adornment data for original file. */
    originalFilegutterAdornments: IGutterAdornmentBlock[];
}

export enum IndicatorType {
    
    /** Succeeded. */
    Succeeded,

    /** Warning. */
    Warning,

    /** Error. */
    Error
}
